<template>
  <div>
    <div class="ng-header">
      <div class="w1200 top-header">
        <div class="ng-site-logo">
          <a :href="CurrentEnvPrefix.main">
            <img
              :src="
                CurrentEnvPrefix.qiniu +
                  '/data/upload/shop/common/' +
                  site_logo.value
              "
            />
          </a>
        </div>
        <div
          class="ng-head-search-bar"
          id="search"
          v-on:mouseleave="hiddensearch()"
        >
          <ul class="ng-tab">
            <li
              :class="{ current: tabnum == index }"
              v-for="(tab, index) in tab"
              :key="tab"
              @click="tabsearchClick(index, tab)"
            >
              {{ tab }}
            </li>
          </ul>
          <div style="width:100%;display:inline-block;">
            <div class="search-form">
              <input type="hidden" name="" value="search" />
              <input
                type="text"
                name=""
                placeholder="请输入商品关键字"
                class="input-text"
                @click="searchClick()"
                ref="inputname"
                v-if="tabnum == 0"
              />
              <input
                type="text"
                name=""
                placeholder="请输入厂家关键字"
                class="input-text"
                @click="searchClick()"
                ref="inputname"
                v-if="tabnum == 1"
              />

              <label>
                <input
                  type="submit"
                  name=""
                  value=""
                  class="input-submit"
                  @click="searchsureClick()"
                />
                <img
                  src="../../assets/image/search1.png"
                  style="position: absolute;right: 23px;top: 3px;width: 30px;cursor: pointer;"
                />
              </label>
            </div>
            <div
              style="position: relative;cursor:pointer;margin-left:7px;overflow:hidden;width:106px;height:40px;font-size:12px;background-color: #fff;color: rgba(255, 46, 49, 1);border-radius: 8px;border:2px solid #FF3838;float:left;line-height:36px;text-align:center;"
            >
              <label>
                <span
                  ><label
                    ><img
                      src="../../assets/image/camera1.png"
                      style="width:20px;vertical-align:text-bottom"/>
                    以图搜款<input
                      type="file"
                      id="file"
                      name="card_z"
                      accept="image/png,image/jpeg,image/gif"
                      class="input-file"
                      hidefocus="true"
                      @change="uploadChange"
                      ref="upload"/></label
                ></span>
                <input
                  type="file"
                  name="file_search"
                  hidefocus="true"
                  size="1"
                  class="input-file"
                  style="width:0px;height: 26px;opacity: 0;cursor: pointer;border: 0;"
                />
              </label>
            </div>
          </div>
          <div class="ng-search-tip" v-show="hotshow">
            <div class="ng-search-history">
              <div class="ng-h-title">
                历史记录<a href="javascript:;" @click="delword()">清除</a>
              </div>
              <ul class="ng-h-list" style="height:82px;overflow:hidden;">
                <li v-for="list in searchlist" v-if="goodssearch">
                  <a href="javascript:;">{{ list }}</a>
                </li>
                <li v-for="list in storesearchlist" v-else>
                  <a href="javascript:;">{{ list }}</a>
                </li>
              </ul>
              <div class="ng-h-title">好货推荐</div>
              <div class="ng-h-goods">
                <a
                  :href="list.ads[0].url"
                  v-if="list.ads"
                  :title="list.adv_title"
                >
                  <img :src="list.ads[0].pic" />
                </a>
              </div>
            </div>
            <div class="ng-search-hot" v-if="brandlist.length <= 6">
              <div class="ng-h-title">热门推荐...</div>
              <!-- <ul class="ng-hot-list">
					    			<li v-for="keyword in goodskeyword" @click="kwsearchClick(keyword)"><a href="javascript:;">{{keyword}}</a></li>
					    		</ul> -->
              <ul class="ng-hot-brand">
                <li v-for="list in brandlist">
                  <a :href="list.ads[0].url"><img :src="list.ads[0].pic"/></a>
                </li>
              </ul>
            </div>
            <div class="ng-search-hot1" v-if="brandlist.length > 6">
              <div class="ng-h-title">热门推荐...</div>
              <!-- <ul class="ng-hot-list">
                                    <li v-for="keyword in goodskeyword" @click="kwsearchClick(keyword)"><a href="javascript:;">{{keyword}}</a></li>
                                </ul> -->
              <ul class="ng-hot-brand1">
                <li v-for="list in brandlist">
                  <a :href="list.ads[0].url"><img :src="list.ads[0].pic"/></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="ng-keyword">
            <ul>
              <li
                v-for="keyword in goodskeyword"
                @click="kwsearchClick(keyword)"
              >
                <a href="javascript:;">{{ keyword }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div style="float:right;text-align:right;width:260px;height:90px;overflow:hidden;padding-top:10px">
				      	<a target="_blank" :href="CurrentEnvPrefix.main+'/shop/index.php?act=index&amp;op=download'"><img style="width: 200px" src="http://www.zhaojiafang.com/shop/templates/default/images/app_code.png"></a>
				    </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { CurrentEnvPrefix } from "config/urlprefix.js";
export default {
  data() {
    return {
      CurrentEnvPrefix,
      hotshow: false,
      hotkeyword: [],
      goodskeyword: [],
      tab: ["商品", "厂家"],
      tabnum: 0,
      goodssearch: true,
      searchlist: [],
      storesearchlist: [],
      list: [],
      brandlist: [],
      site_logo: {}
    };
  },
  methods: {
    tabsearchClick(index, tab) {
      this.tabnum = index;
      if (tab === "批量铺货") {
        this.$router.push("/landingPage");
      }
      if (index == 1) {
        this.goodssearch = false;
      } else {
        this.goodssearch = true;
      }
      this.getHotKeyWord();
    },
    searchClick() {
      this.hotshow = true;
    },
    hiddensearch() {
      this.hotshow = false;
    },
    getHotKeyWord() {
      this.$Api.get({ api: "/fragment/hotkeywords" }).then(response => {
        this.hotkeyword = response.data.datas;
        if (this.goodssearch) {
          this.goodskeyword = this.hotkeyword.goods;
        } else {
          this.goodskeyword = this.hotkeyword.store;
        }
      });
    },
    uploadChange(e) {
      var files = e.target.files[0];
      var _formData = new FormData();
      const _this = this;
      _formData.append("name", "card_z");
      _formData.append("key", this.$Api.getMKey());
      _formData.append("card_z", files);
      this.$Api
        .uploadResource(
          {
            api: "/mobile/index.php?act=goods&op=search",
            formdata: _formData
          },
          function(callbackProgress) {
            _this.$nextTick(() => {
              _this.progress = callbackProgress;
              // console.log(_this.progress)
            });
          },
          function(callBackResult) {
            //处理数据，跳到goodslist页面
            var param = callBackResult.data || [];
            var result = param.length > 0 ? param[0] : null;
            const images = param.length > 0 ? param[1] : null;
            if (result || images) {
              var href =
                CurrentEnvPrefix.main +
                "/shop/index.php?act=search&op=goods_search&goods_id_list=" +
                result +
                "&img=" +
                images;
              window.location.href = href;
            }
          }
        )
        .then(response => {});
    },
    searchsureClick() {
      var keyword = this.$refs.inputname.value;
      this.kwsearchClick(keyword);
    },
    kwsearchClick(keyword) {
      if (this.goodssearch) {
        this.Common.setGoodsword(keyword);
        window.location.href =
          CurrentEnvPrefix.main +
          "/shop/index.php?act=search&op=index&keyword=" +
          keyword;
      } else {
        this.Common.setStoreword(keyword);
        window.location.href =
          CurrentEnvPrefix.main + "/shop/?act=store_list&keyword=" + keyword;
      }
    },
    delword() {
      if (this.goodssearch) {
        this.$dialog.confirm({
          mes: "确定要删除全部历史搜索吗？",
          opts: () => {
            this.Common.delGoodsword();
            this.searchlist = this.Common.getGoodsword();
          }
        });
      } else {
        this.$dialog.confirm({
          mes: "确定要删除全部历史搜索吗？",
          opts: () => {
            this.Common.delGoodsword();
            this.storesearchlist = this.Common.getStoreword();
          }
        });
      }
    },
    getList() {
      this.$Api
        .get({
          api: "/ad/list",
          param: { ad_type: "commonsearch.history.ads" }
        })
        .then(response => {
          var datas = response.data.datas;
          var lastindex = this.$cookie.get("hhtj") || "";
          if (lastindex == "") {
            lastindex = 0;
            this.$cookie.set("hhtj", lastindex, "1D");
          } else {
            lastindex = lastindex == 0 ? 1 : 0;
          }
          this.$cookie.set("hhtj", lastindex, "1D");
          this.list = datas[lastindex];
        });
    },
    getBrandList() {
      this.$Api
        .get({ api: "/ad/list", param: { ad_type: "commonsearch.brandlist" } })
        .then(response => {
          this.brandlist = response.data.datas;
        });
    },
    getLogo() {
      this.$Api
        .get({
          api: this.Common.getSourec().plapi + "/setting/fragment_setting_list"
        })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            var data = response.data.datas;
            this.site_logo = data.site_logo;
          } else {
            this.$dialog.toast({ mes: response.data.ResponseMsg });
          }
        });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getHotKeyWord();
    this.getLogo();
    window.addEventListener("scroll", this.handleScroll);
    this.searchlist = this.Common.getGoodsword() || [];
    for (var i = 0; i < this.searchlist.length; i++) {
      for (var m = 0; m < this.searchlist.length; m++) {
        if (i != m && this.searchlist[i] == this.searchlist[m]) {
          this.searchlist.splice(m, 1);
        }
      }
    }
    this.storesearchlist = this.Common.getStoreword() || [];
    for (var i = 0; i < this.storesearchlist.length; i++) {
      for (var m = 0; m < this.storesearchlist.length; m++) {
        if (i != m && this.storesearchlist[i] == this.storesearchlist[m]) {
          this.storesearchlist.splice(m, 1);
        }
      }
    }
    this.getList();
    this.getBrandList();
  }
};
</script>
<style scoped>
.input-file {
  display: none;
}
.ng-h-goods {
  width: 100%;
  padding: 0 8px;
}
.ng-h-goods img {
  width: 100%;
  height: 180px;
}
.ng-hot-brand {
  width: 415px;
}
.ng-hot-brand li {
  width: 117px;
  float: left;
  height: 142px;
  margin-right: 15px;
  margin-top: 6px;
}
.ng-hot-brand,
.ng-hot-brand1 {
  padding: 0 10px;
  display: inline-block;
}
.ng-hot-brand1 li {
  width: 117px;
  float: left;
  height: 142px;
  margin-right: 5px;
  margin-top: 6px;
}
.ng-hot-brand li:nth-child(3n) {
  margin-right: 0;
}
.ng-hot-brand li img,
.ng-hot-brand1 li img {
  width: 100%;
  height: 142px;
}
.ng-hot-brand1 li:nth-child(4n) {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue